
function MeuCupom(){
    return <div>
        
        <h1>Meu Cupom</h1>
    </div>
}

export default MeuCupom;